import {
  Component,
  ElementRef,
  HostListener,
  Input,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { Font, FontService } from '../font.service';
import { BehaviorSubject, Observable, Subscription, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { CanvasService } from '../../../../../services/canvas/canvas.service';
import { Store } from '@ngrx/store';
import { setDescriptorValue } from '../../../../store/editor.crud.actions';
import { bulkUpdateFinish } from '../../../../store/editor.actions';

@Component({
  selector: 'nw-font-family-selector',
  templateUrl: './font-family-selector.component.html',
  styleUrls: ['./font-family-selector.component.scss'],
})
export class FontFamilySelectorComponent implements OnDestroy {
  @ViewChild('search') searchElement: ElementRef;

  fonts$: Observable<Font[]>;
  showSelector = false;
  private searchText$ = new BehaviorSubject<string>('');
  clickSub: Subscription;
  searchText = 'Search';
  selectedFont: string;
  currentFontFamily: string;

  @Input()
  set fontFamily(val: string) {
    this.currentFontFamily = val;
  }

  get fontFamilyToDisplay() {
    return this.currentFontFamily;
  }

  defaultFonts: Font[] = [
    'Arial',
    'Verdana',
    'Tahoma',
    'Times New Roman',
    'Georgia',
    'Courier New',
    'Trebuchet MS',
    'Comic Sans MS',
    'sans-serif',
    'serif',
    'monospace',
  ].map(name => ({ name, category: 'default' }));

  constructor(
    private readonly service: FontService,
    private readonly cs: CanvasService,
    private readonly store: Store,
    private readonly fontService: FontService,
  ) {
    this.fonts$ = combineLatest([this.service.fonts$, this.searchText$]).pipe(
      map(([fonts, searchText]) => [
        this.defaultFonts.concat(fonts),
        searchText,
      ]),
      map(([fonts, searchText]: [Font[], string]) => {
        if (!searchText) {
          return fonts;
        }
        return fonts.filter(font =>
          font.name.split(' ').find(word => word.startsWith(searchText)),
        );
      }),
    );
  }

  get searchTextBaseFormat() {
    return this.searchText.charAt(0).toUpperCase() + this.searchText.slice(1);
  }

  updateFontFamily(value: string) {
    this.store.dispatch(
      setDescriptorValue({
        key: 'textConfig',
        innerKey: 'fontFamily',
        value,
      }),
    );
  }

  finishUpdate() {
    this.store.dispatch(bulkUpdateFinish());
  }

  ngOnDestroy(): void {}
  ngAfterViewInit() {
    this.clickSub = this.cs.clickEvent.subscribe(() => {
      this.showSelector = false;
    });
  }

  close() {
    // -- // -- //
  }

  toggleSelector() {
    if (this.showSelector) {
      this.showSelector = false;
      return;
    }
    this.showSelector = true;
    this.searchText = 'Search';
    setTimeout(() => {
      this.focusInput();
    });
  }

  focusInput() {
    this.searchElement.nativeElement.focus();
    this.searchElement.nativeElement.setSelectionRange(
      0,
      100,
      // this.searchText.length,
    );
  }
  openList() {
    console.log('open-list');
  }

  searchTextChange(event: Event) {
    event.stopPropagation();
    const value = (event.target as HTMLInputElement).value;

    const searchText = value.charAt(0).toUpperCase() + value.slice(1);
    this.searchText$.next(searchText);
  }

  @HostListener('wheel', ['$event'])
  onWheel(event: WheelEvent) {
    event.stopPropagation();
  }

  selectFont(font: Font) {
    this.updateFontFamily(font.name);
    this.fontService._loadFont(font.name).then(() => {
      this.finishUpdate();
    });
    this.showSelector = false;
  }
}
